export const dhConfig1000hPa = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_SS_AMTCLD_1000hPa_MAX/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "WX_SS_SCALE_1000",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_SS_AMTCLD_1000hPa_MAX_%validtime%/%z%_%y%_%x%.png?latestValid=%latestValid%",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 1,
        "MaxZoom": 5,
        "YCoordinate": -1,
        "BoundingBox": {
          "West": 120,
          "South": 22,
          "East": 150,
          "North": 48
        }
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};
export const dhConfig975hPa = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_SS_AMTCLD_975hPa_MAX/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "WX_SS_SCALE_975",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_SS_AMTCLD_975hPa_MAX_%validtime%/%z%_%y%_%x%.png?latestValid=%latestValid%",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 1,
        "MaxZoom": 5,
        "YCoordinate": -1,
        "BoundingBox": {
          "West": 120,
          "South": 22,
          "East": 150,
          "North": 48
        }
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};
export const dhConfig950hPa = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_SS_AMTCLD_950hPa_MAX/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "WX_SS_SCALE_950",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_SS_AMTCLD_950hPa_MAX_%validtime%/%z%_%y%_%x%.png?latestValid=%latestValid%",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 1,
        "MaxZoom": 5,
        "YCoordinate": -1,
        "BoundingBox": {
          "West": 120,
          "South": 22,
          "East": 150,
          "North": 48
        }
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};
export const dhConfig925hPa = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_SS_AMTCLD_925hPa_MAX/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "WX_SS_SCALE_925",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_SS_AMTCLD_925hPa_MAX_%validtime%/%z%_%y%_%x%.png?latestValid=%latestValid%",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 1,
        "MaxZoom": 5,
        "YCoordinate": -1,
        "BoundingBox": {
          "West": 120,
          "South": 22,
          "East": 150,
          "North": 48
        }
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};
export const dhConfig900hPa = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_SS_AMTCLD_900hPa_MAX/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "WX_SS_SCALE_900",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_SS_AMTCLD_900hPa_MAX_%validtime%/%z%_%y%_%x%.png?latestValid=%latestValid%",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 1,
        "MaxZoom": 5,
        "YCoordinate": -1,
        "BoundingBox": {
          "West": 120,
          "South": 22,
          "East": 150,
          "North": 48
        }
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};
export const dhConfig850hPa = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_SS_AMTCLD_850hPa_MAX/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "WX_SS_SCALE_850",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_SS_AMTCLD_850hPa_MAX_%validtime%/%z%_%y%_%x%.png?latestValid=%latestValid%",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 1,
        "MaxZoom": 5,
        "YCoordinate": -1,
        "BoundingBox": {
          "West": 120,
          "South": 22,
          "East": 150,
          "North": 48
        }
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};
export const dhConfig800hPa = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_SS_AMTCLD_800hPa_MAX/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "WX_SS_SCALE_800",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_SS_AMTCLD_800hPa_MAX_%validtime%/%z%_%y%_%x%.png?latestValid=%latestValid%",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 1,
        "MaxZoom": 5,
        "YCoordinate": -1,
        "BoundingBox": {
          "West": 120,
          "South": 22,
          "East": 150,
          "North": 48
        }
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};
export const dhConfig700hPa = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_SS_AMTCLD_700hPa_MAX/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "WX_SS_SCALE_700",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_SS_AMTCLD_700hPa_MAX_%validtime%/%z%_%y%_%x%.png?latestValid=%latestValid%",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 1,
        "MaxZoom": 5,
        "YCoordinate": -1,
        "BoundingBox": {
          "West": 120,
          "South": 22,
          "East": 150,
          "North": 48
        }
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};
export const dhConfig600hPa = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_SS_AMTCLD_600hPa_MAX/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "WX_SS_SCALE_600",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_SS_AMTCLD_600hPa_MAX_%validtime%/%z%_%y%_%x%.png?latestValid=%latestValid%",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 1,
        "MaxZoom": 5,
        "YCoordinate": -1,
        "BoundingBox": {
          "West": 120,
          "South": 22,
          "East": 150,
          "North": 48
        }
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};
export const dhConfig500hPa = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_SS_AMTCLD_500hPa_MAX/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "WX_SS_SCALE_500",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_SS_AMTCLD_500hPa_MAX_%validtime%/%z%_%y%_%x%.png?latestValid=%latestValid%",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 1,
        "MaxZoom": 5,
        "YCoordinate": -1,
        "BoundingBox": {
          "West": 120,
          "South": 22,
          "East": 150,
          "North": 48
        }
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};
export const dhConfig400hPa = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_SS_AMTCLD_400hPa_MAX/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "WX_SS_SCALE_400",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_SS_AMTCLD_400hPa_MAX_%validtime%/%z%_%y%_%x%.png?latestValid=%latestValid%",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 1,
        "MaxZoom": 5,
        "YCoordinate": -1,
        "BoundingBox": {
          "West": 120,
          "South": 22,
          "East": 150,
          "North": 48
        }
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};
export const dhConfig300hPa = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_SS_AMTCLD_300hPa_MAX/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "WX_SS_SCALE_300",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_SS_AMTCLD_300hPa_MAX_%validtime%/%z%_%y%_%x%.png?latestValid=%latestValid%",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 1,
        "MaxZoom": 5,
        "YCoordinate": -1,
        "BoundingBox": {
          "West": 120,
          "South": 22,
          "East": 150,
          "North": 48
        }
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};

// Layer
export const layerConfigSsScale = {
  "Name": "SsScale",
  "Renderer": "Image",
  "Attributes": {
    "style": {
      "default": {
        "type": "grayscale_palette",
        "mag_filter": "NEAREST",
        "alternative_color": [0, 0, 0, 0],
        "palette": [
          [0, 0, 0, 0],       // x
          [0, 102, 255, 100], // SKC
          [0, 255, 255, 100], // FEW
          [0, 255, 0, 100],   // SCT
          [255, 255, 0, 100], // BKN
          [255, 0, 0, 100]    // OVC
        ]
      }
    }
  }
};
